import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import PersonaSelectPage from "./pages/PersonaSelectPage";
import RecorderPage from "./pages/RecorderPage";
import PlaybackPage from "./pages/PlaybackPage";
import PricingPage from "./pages/PricingPage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";
import ProfilePage from "./pages/ProfilePage";
import "./App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-screen">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      </Layout>
    );
  }
  
  if (!user) {
    return <Navigate to="/auth" replace />;
  }
  
  if (!user.disclaimer_accepted) {
    return <Navigate to="/disclaimer" replace />;
  }
  
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster 
          position="top-center" 
          toastOptions={{
            style: {
              background: 'hsl(24 10% 14%)',
              color: 'hsl(40 18% 95%)',
              border: '1px solid hsl(24 10% 18%)',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Navigate to="/welcome" replace />} />
          <Route path="/welcome" element={<Layout><LandingPage /></Layout>} />
          <Route path="/disclaimer" element={<Navigate to="/welcome" replace />} />
          <Route path="/auth" element={<Layout><AuthPage /></Layout>} />
          <Route path="/forgot-password" element={<Layout><ForgotPasswordPage /></Layout>} />
          <Route path="/pricing" element={<Layout><PricingPage /></Layout>} />
          <Route path="/subscription/success" element={<Layout><SubscriptionSuccessPage /></Layout>} />
          <Route 
            path="/persona" 
            element={
              <ProtectedRoute>
                <Layout><PersonaSelectPage /></Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/vent" 
            element={
              <ProtectedRoute>
                <Layout><RecorderPage /></Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/playback" 
            element={
              <ProtectedRoute>
                <Layout><PlaybackPage /></Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Layout><ProfilePage /></Layout>
              </ProtectedRoute>
            } 
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
